import TractorDetails from "./TractorDetails";

export default TractorDetails;
